const IBAN_STATUS = {
  EXPERIMANTAL: "experimental",
  MANDATORY: "mandatory",
  NONE: "none",
  RECOMMENDED: "recommended",
};

export default IBAN_STATUS;
